// Auto-import all JSON files from Decap CMS.
const cmsContext = require.context('./cms/jobs', false, /\.json$/);
const cmsJobs = cmsContext.keys().map((key) => {
  const data = cmsContext(key);
  return {
    id: data.slug,
    slug: data.slug,
    title: data.title,
    positions: data.positions ?? 1,
    isOpen: data.isOpen ?? true,
    location: data.location ?? null,
    jobType: data.jobType ?? null,
    intro: data.intro ?? null,
    jobDescriptions: data.jobDescriptions ?? null,
    responsibilities: data.responsibilities ?? null,
    requirements: data.requirements ?? null,
    benefits: data.benefits ?? null,
    applyEmail: data.applyEmail ?? '',
    applyPhone: data.applyPhone ?? '',
  };
});

export const jobs = cmsJobs;
